import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.3619 7.13438C13.6541 7.42791 13.6531 7.90278 13.3596 8.19504L10.2904 11.251H18.9986C19.4128 11.251 19.7486 11.5868 19.7486 12.001C19.7486 12.4153 19.4128 12.751 18.9986 12.751H10.2937L13.3599 15.8074C13.6532 16.0998 13.654 16.5747 13.3616 16.8681C13.0692 17.1614 12.5943 17.1622 12.3009 16.8698L7.98332 12.566C7.82596 12.4286 7.72656 12.2264 7.72656 12.001C7.72656 12.0007 7.72656 12.0003 7.72656 11.9999C7.72656 11.9994 7.72656 11.999 7.72656 11.9985C7.72662 11.7991 7.80607 11.608 7.94737 11.4673L12.3012 7.13211C12.5947 6.83984 13.0696 6.84086 13.3619 7.13438Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 5.98828C5.41421 5.98828 5.75 6.32407 5.75 6.73828V17.2631C5.75 17.6773 5.41421 18.0131 5 18.0131C4.58579 18.0131 4.25 17.6773 4.25 17.2631V6.73828C4.25 6.32407 4.58579 5.98828 5 5.98828Z",
		fill: "currentColor"
	})]
});
export default SvgLeftLine;
